<script>
  import {styleVars} from '/helper'
  import Card from '/components/Atoms/Card.svelte'

  export let title, subtitle, image, image2x, imageWebp, imageWebp2x, standardRadius = false, highlight = false

  // $: console.log($$slots.default)
</script>

<Card bgImage={image} bgImage2x={image2x} bgImageWebp={imageWebp} bgImageWebp2x={imageWebp2x} {standardRadius} >
  <div class="container" class:highlight={highlight}>
    <h2 class="category">
      &nbsp;
    </h2>
    <div class="middle">
      {#if title}
        <h3 class="title">
          {title}
        </h3>
      {/if}
      {#if subtitle}
        <h4 class="subtitle">
          {subtitle}
        </h4>
      {/if}
    </div>
    <span class="category">&nbsp;</span>
  </div>
</Card>

<style lang="scss">


  .container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    text-align: center;
  }
  
  .category {
    @include typo-serif-small-caps-28-small;
    color: $color-red;
  }

  .middle {
    color: $color-mint;
    padding-top: 37px;
    padding-bottom: 37px;
  }

  .title {
    @include typo-grotesk-title-30-small;
    .highlight & {
      @include typo-grotesk-title-50-small;
    }
  }

  .subtitle {
    @include typo-grotesk-text-24-small;
  }

</style>